<div class="main-content">
  <div class="form-box">
    <router-outlet></router-outlet>
  </div>
</div>
 